import { render, staticRenderFns } from "./LmReaderInput.vue?vue&type=template&id=2452cead&"
import script from "./LmReaderInput.vue?vue&type=script&lang=js&"
export * from "./LmReaderInput.vue?vue&type=script&lang=js&"
import style0 from "./LmReaderInput.vue?vue&type=style&index=0&id=2452cead&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports